import { FileCard } from "../FileCard";
import { ImageAttachmentFileCard } from "./attachmentImageCard";
import { useAttachmentContext } from "../../../contexts/AttachmentContext";

export const AttachedFilesSection: React.FC = () => {
  const { textFiles, imageFiles } = useAttachmentContext();

  if ((!textFiles || textFiles.length === 0) && (!imageFiles || imageFiles.length === 0)) {
    return null;
  }

  return (
    <div 
      className="attached-files-section"
      aria-label="Attached files"
    >
      {textFiles.map(file => (
        <FileCard
          key={file.id}
          file={file}
        />
      ))}
      {imageFiles.map(file => (
        <ImageAttachmentFileCard
          key={file.id}
          imageFile={file}
        />
      ))}
    </div>
  );
};
